import React from 'react';

interface CountryFlagProps {
    countryCode: string;
    countryName: string;
}

const CountryFlag: React.FC<CountryFlagProps> = ({ countryCode, countryName }) => {
    // Handle multi-country codes
    const codes = countryCode.split('-');

    if (codes.length > 1) {
        return (
            <React.Fragment>
                {codes.map((code, index) => (
                    <img
                        key={index}
                        alt={`${countryName} Flag`}
                        src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${code}.svg`}
                        className={`w-4 inline-block align-middle mx-1 mb-0.5 ${
                            code === 'ID' || code === 'SG' ? 'border border-1' : ''
                        }`}
                        width={4}
                        height={4}
                        loading="lazy"
                    />
                ))}
            </React.Fragment>
        );
    }

    const needsBorder = countryCode === 'ID' || countryCode === 'SG';

    return (
        <img
            alt={`${countryName} Flag`}
            src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode}.svg`}
            className={`w-4 inline-block align-middle mx-1 mb-0.5 ${needsBorder ? 'border border-1' : ''}`}
            width={4}
            height={4}
            loading="lazy"
        />
    );
};

export default CountryFlag;